module.exports = __webpack_public_path__ + "media/budapest/bastion_stairs2-0dcc6fca.jpg";